/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Situationaddpayment2Inputs */

const en_situationaddpayment2 = /** @type {(inputs: Situationaddpayment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a payment receipt to back up what you paid`)
};

const pt_situationaddpayment2 = /** @type {(inputs: Situationaddpayment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione um recibo para confirmar o que pagou`)
};

/**
* | output |
* | --- |
* | "Add a payment receipt to back up what you paid" |
*
* @param {Situationaddpayment2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const situationaddpayment2 = /** @type {((inputs?: Situationaddpayment2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Situationaddpayment2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_situationaddpayment2(inputs)
	return pt_situationaddpayment2(inputs)
});
export { situationaddpayment2 as "situationAddPayment" }